<template>
  <div class="sg-search-content">
    <div class="sg-search-navbar">
      <div
        class="sg-search-navbar-icon"
        @click="back()">
        <img
          class="sg-search-navbar-icon-back"
          src="../assets/images/nav/back1.png" />
      </div>
      <div class="sg-search-navbar-search">
        <img
          class="sg-search-navbar-search-icon"
          src="../assets/images/home/search.png" />
        <input
          v-model="tagVal"
          type="text"
          placeholder="输入关键词查找资源" />
      </div>
      <div
        class="sg-search-navbar-item"
        @click="searchChange()">搜索</div>
    </div>
    <div class="sg-search-contenter">
      <div class="sg-search-contenter-title">
        历史搜索
        <img
          class="sg-search-contenter-clear"
          src="../assets/images/home/clear.png"
          @click="clear()"/>
      </div>
      <div class="sg-search-contenter-tags-cell">
        <div
          v-for="(item, index) in lsList"
          :key="index"
          class="sg-search-contenter-tags"
          @click="lsTagsChange(index)">{{item}}</div>
      </div>
      <div
        v-for="(items, index) in tags"
        :key="index">
        <div class="sg-search-contenter-title">{{items.title}}</div>
        <div class="sg-search-contenter-tags-cell">
          <div
            v-for="(item, index1) in items.lists"
            :key="index1"
            class="sg-search-contenter-tags"
            @click="tagChange(index,index1)">{{item}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selecTagstList } from '@/API/search'
export default {
  name: 'search',
  data () {
    return {
      tags: [],
      tagVal: '',
      lsList: '',
      listStr: ''
    }
  },
  created () {
    this.getTagsList()
    if (
      localStorage.getItem('listStr') != null &&
      localStorage.getItem('listStr') !== ''
    ) {
      this.listStr = localStorage.getItem('listStr')
      this.lsList = this.listStr.split(',')
    }
  },
  methods: {
    getTagsList () {
      selecTagstList()
        .then(res => {
          this.tags = res.rescont
        })
        .catch(err => {
          console.log(err)
        })
    },
    clear () {
      this.listStr = ''
      this.lsList = []
      localStorage.removeItem('listStr')
    },
    tagChange (row, cell) {
      this.tagVal = this.tags[row].lists[cell]
      this.addtags(this.tagVal)
      this.$router.push({
        path: '/searchList?key=' + row + cell,
        query: {
          search: this.tagVal
        }
      })
    },
    searchChange () {
      this.addtags(this.tagVal)
      this.$router.push({
        path: '/searchList',
        query: {
          search: this.tagVal
        }
      })
    },
    addtags (val) {
      if (this.listStr === '') {
        this.listStr = val
      } else {
        for (let i = 0; i < this.listStr.split(',').length; i++) {
          if (this.listStr.split(',')[i] === val) {
            break
          } else {
            if (i === this.listStr.split(',').length - 1) {
              this.listStr = this.listStr + ',' + val
            }
          }
        }
      }
      localStorage.setItem('listStr', this.listStr)
    },
    lsTagsChange (index) {
      this.tagVal = this.lsList[index]
      this.$router.push({
        path: '/searchList',
        query: {
          search: this.tagVal
        }
      })
    },
    back () {
      this.$router.go(-1) // 返回上壹層
    }
  }
}
</script>
<style scoped>
.sg-search-content {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
}

.sg-search-navbar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: inline-flex;
  width: 100%;
  height: 44px;
  background-color: #000;
}

.sg-search-navbar-icon {
  box-sizing: border-box;
  width: 54px;
  height: 44px;
  padding: 10px 15px;
}

.sg-search-navbar-icon-back {
  width: 13px;
  height: 20px;
  margin-top: 2px;
}

.sg-search-navbar-item {
  width: 60px;
  height: 44px;
  margin: 0 15px;
  font-size: 16px;
  font-weight: 600;
  line-height: 44px;
  color: #eab87f;
}

.sg-search-navbar-search {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: 100%;
  height: 30px;
  padding: 5px 17px;
  margin: 7px 0;
  line-height: 20px;
  background-color: rgba(40, 40, 40, 1);
  border-radius: 15px;
}

.sg-search-navbar-search-icon {
  width: 20px;
  height: 20px;
}

.sg-search-navbar-search input {
  width: 100%;
  height: 20px;
  margin-left: 10px;
  font-size: 14px;
  color: #fff;
  background-color: rgba(40, 40, 40, 1);
  border: 0;
  outline: none;
}

.sg-search-contenter {
  position: absolute;
  top: 44px;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 15px 15px;
  overflow-y: auto;
}

.sg-search-contenter-title {
  position: relative;
  width: 100%;
  height: 40px;
  font-size: 15px;
  font-weight: 400;
  line-height: 40px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
}

.sg-search-contenter-clear {
  position: absolute;
  top: 10px;
  right: 15px;
  width: 20px;
  height: 20px;
}

.sg-search-contenter-tags-cell {
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 100%;
}

.sg-search-contenter-tags {
  box-sizing: border-box;
  height: 25px;
  padding: 0 13px;
  margin-right: 2.5vw;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  color: #eab87f;
  text-align: center;
  background: rgba(255, 243, 240, 1);
  border-radius: 12.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue